import React from "react";

import { Box, Card, CardActionArea, CardActions, CardContent, Grid, Typography } from "@material-ui/core";
import { useTheme, withStyles } from "@material-ui/core/styles";

import numberFormatter from "utils/numberFormatter";
import BarChart from "pages/customer/tools/product/filters/BarChart";
import { Range } from "modules/customer/tools/product/storeRangeFilters/range";

const StyledCard = withStyles(theme => ({
    root: {
        // @ts-ignore
        backgroundColor: theme.palette.quaternary.main,
        borderColor: (props: any) => props["data-selected"] ? theme.palette.common.white : "transparent",
        borderStyle: "solid",
        borderWidth: "1px",
        height: "100%"
    }
}))(Card);

const StyledCardActions = withStyles(theme => ({
    root: {
        // @ts-ignore
        backgroundColor: theme.palette.quaternary.light
    }
}))(CardActions);

const StyledCardActionArea = withStyles(theme => ({
    root: {
        height: "100%",
        minWidth: "100%"
    }
}))(CardActionArea);

const StyledCardContent = withStyles(theme => ({
    root: {
        // @ts-ignore
        backgroundColor: theme.palette.quaternary.main
    }
}))(CardContent);

interface StoreCardProps {
    range: Range,
    selected: boolean,
    onSelect: (range: Range) => void,
    onDeselect: (range: Range) => void
}

const RangeCard: React.FC<StoreCardProps> = (props) => {
    const { range, selected, onSelect, onDeselect } = props;
    const theme = useTheme();
    const showLabel = false;

    const handleClick = () => {
        if (selected) {
            onDeselect(range);
        } else {
            onSelect(range);
        }
    };

    return (
        <StyledCard elevation={0} data-selected={selected}>
            <StyledCardActionArea onClick={handleClick} disableRipple disableTouchRipple>
                <StyledCardActions style={{ height: theme.spacing(12) }}>
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <Typography
                                variant="h6"
                                component="div"
                                align="center"
                            >
                                {range.name}
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography
                                variant="body1"
                                component="div"
                                align="center"
                                noWrap
                                style={{ color: theme.palette.text.secondary }}
                            >
                                Headroom
                            </Typography>
                            <Typography
                                variant="h5"
                                component="div"
                                align="center"
                            >
                                {numberFormatter.toGBP(range.sales.salesHeadroom, 1)}
                            </Typography>
                        </Grid>
                    </Grid>
                </StyledCardActions>
                <StyledCardContent>
                    <BarChart sales={range.sales} />
                </StyledCardContent>
                {showLabel && <StyledCardActions>
                    <Box display="flex" justifyContent="center" alignItems="center" width="100%">
                        <Typography
                            variant="h6"
                            component="span"
                            align="center"
                            display="inline"
                            style={{ color: theme.palette.text.primary }}
                        >
                            Range
                        </Typography>
                    </Box>
                </StyledCardActions>}
            </StyledCardActionArea>
        </StyledCard>
    );
};

export default RangeCard;
